<template>
  <!-- class="topBar" -->
  <v-app-bar
    fixed
    app
    style="
      font-family:
        'Avantgarde', 'TeX Gyre Adventor', 'URW Gothic L', sans-serif;
      background: linear-gradient(to right, #052d52, transparent);
    "
    extension-height="100"
    min-height="40px"
    max-height="40px"
    id="top"
  >
    <v-col cols="2" class="pt-0 pb-0 px-0">
      <!-- <v-card 
          class="transparent"
          min-height="50px"
          max-height="50px"
          min-width="250px"
          max-width="250px"
        > -->
      <v-img
        class="mt-0 pl-0 ml-0"
        min-height="40px"
        max-height="40px"
        min-width="240px"
        max-width="240px"
        src="../assets/images/newLogo.png"
      ></v-img>
      <!-- </v-card> -->
      <!-- mdi-swap-horizontal -->
    </v-col>
    <v-col cols="5" class="pb-0 pt-0">
      <div
        class="d-flex justify-bottom"
        v-if="
          !storedGroups.includes('subscribers') &&
          storedGroups.includes('clients')
        "
      >
        <!-- <v-alert class="py-1 mt-5" text outlined dismissible> -->
        <!-- Click
          <a class="link" style="color: #007bff" text-decoration="none" target="_blank"
            href="https://stripe.com/billing?utm_campaign=US_en_Search_Nonbrand_Billing-Core_EXA-13880767415&utm_medium=cpc&utm_source=google&ad_content=608926659321&utm_term=recurring%20billing%20platform&utm_matchtype=e&utm_adposition=&utm_device=c&gclid=Cj0KCQjw3eeXBhD7ARIsAHjssr_AKDUNiu1dSjmy0-9eA6X6G5l69YTw8T-KzgubiO_UVFliVEANp7IaAo3jEALw_wcB">
            here
          </a>
          to subscribe and join AGT! -->
        <!-- Become a subscriber and Join AGT -->
        <!-- </v-alert> -->
      </div>
      <div
        cols="2"
        class="d-none d-lg-block"
        v-if="!storedGroups.includes('clients')"
      >
        <tr>
          <th width="125px" align="start">Trafix Connection</th>
          <td>
            <h4 v-if="connection" class="icon69">Connected</h4>
            <h4 v-else-if="!connection" class="icon70">Disconnected</h4>
          </td>
          <td>
            <h4 v-if="loggedInToTrafix" class="icon69">Logged In</h4>
            <h4 v-if="!loggedInToTrafix" class="icon70">Not Logged In</h4>
          </td>
        </tr>
        <!-- <tr>
          <th width="125px" align="start">Trafix Connection</th>
          <td>
            <h4 v-if="connection" class="icon69">Connected</h4>
            <h4 v-if="!connection" class="icon70">Disconnected</h4>
          </td>
          <td>
            <h4 v-if="loggedInToTrafix" class="icon69">Logged In</h4>
            <h4 v-if="!loggedInToTrafix" class="icon70">Not Logged In</h4>
          </td>
        </tr> -->
      </div>
      <div
        cols="2"
        class="d-none d-lg-block"
        v-if="!storedGroups.includes('clients')"
      >
        <tr>
          <th width="125px" align="start">DxFeed Connection</th>
          <td>
            <h4 v-if="dxconnection" class="icon69">Connected</h4>
            <h4 v-if="!dxconnection" class="icon70">Disconnected</h4>
          </td>
        </tr>
      </div>
    </v-col>
    <v-col cols="2" v-if="Object.keys(marketStatuses).length > 0">
      <tr>
        <td>NASDAQ</td>
        <td :class="marketStatusClasses.nasdaq">{{ marketStatuses.nasdaq }}</td>
      </tr>
      <tr>
        <td>NYSE</td>
        <td :class="marketStatusClasses.nyse">{{ marketStatuses.nyse }}</td>
      </tr>
    </v-col>
    <v-col cols="2" class="pb-0 pt-0" v-if="checkRestrict()">
      <div>
        <v-alert
          dense
          dark
          type="error"
          border="left"
          class="pb-0 mb-0 black--text restrictText"
          style="max-height: 35px; min-height: 35px"
          v-if="checkRestrict()"
        >
          Account Restricted
          <v-btn x-small @click="restrictBox = true" class="ml-5 mb-1"
            >help!
          </v-btn>
        </v-alert>
        <v-dialog
          v-if="userPermissions.restrictReason != null"
          v-model="restrictBox"
          width="400px"
        >
          <v-card v-if="userPermissions.restrictReason" class="px-5" outlined>
            <v-card-title class="d-flex justify-center"
              >Account Restricted
            </v-card-title>
            <v-card-text v-if="userPermissions.restrictReason.length == 1"
              >Restrict Code:
              {{ getRestriction(userPermissions.restrictReason[0]) }}
              <br />
              <br />
              Your account has been restricted, please call one of our brokers
              at 312-360-2323 to discuss.
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </v-col>
    <v-col cols="" class="d-flex justify-end align-center pt-0 pb-0">
      <!-- <v-col cols="" class="d-flex justify-end" v-if="!this.stateOf"> -->
      <div id="words2" class="pt-2 pr-2 mt-1">
        {{ (isImpersonating() ? 'Impersonating: ' : '') + this.email }}
      </div>
      <!-- <v-avatar size="30px" color="transparent" class="mt-2 pr-0 mb-1"> -->
      <v-btn
        right
        color="secondary"
        elevation="2"
        min-height="30"
        class="ml-3 mt-1 mb-1"
        id="drawer"
        @click.stop="openBotChat"
      >
        <v-icon left small>mdi-creation</v-icon>
        <span style="text-transform: none">Research AI</span>
      </v-btn>
      <v-btn
        right
        color="primary"
        elevation="2"
        min-width="80"
        :max-width="isImpersonating() ? '140' : '160'"
        min-height="30"
        class="ml-3 mt-1 mb-1"
        @click="logOut"
      >
        <span style="text-transform: none">Logout</span>
      </v-btn>
      <Bot ref="bot" />
    </v-col>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import { API, Auth, graphqlOperation, Storage } from 'aws-amplify'
import * as queries from '@/graphql/queries.js'
import { createProfilePicture } from '@/graphql/mutations'
import * as mutations from '@/graphql/mutations.js'
import updateemail from '@/components/settings/updateemail.vue'
import ChangePassword from '@/components/settings/ChangePassword.vue'
import * as conversions from '@/mixins/conversinos.mixin.js'
import * as Sentry from '@sentry/vue'
import { isImpersonating } from '@/utils/authUtils'
import Bot from '@/components/Bot.vue'
import { AuthSync } from '@/utils/authSync'

export default {
  components: {
    updateemail,
    ChangePassword,
    Bot,
  },
  name: 'topNavBar',
  props: ['stateBadge'],
  data: () => {
    return {
      loggedInToTrafix: false,
      serviceDown: false,
      restrictBox: false,
      connection: false,
      dxconnection: false,
      interval: null,
      date: '',
      email: '',
      cognitoUserName: '',
      uploadProPic: false,
      uploadFile: null,
      file: null,
      items: [],
      storedGroups: [],
      data: [],
      stateOf: false,
      changeOrUpload: 'Upload',
      proPic: '@/assets/images/prepropic.png',
      proPicId: '',
      marketStatuses: {},
      authSync: null,
    }
  },
  methods: {
    isImpersonating,
    openBotChat() {
      this.$refs.bot?.openChat()
    },
    logOut: async function () {
      // Notify other tabs before logout
      if (this.authSync) {
        this.authSync.broadcastLogout()
      }

      this.$store.commit('resetProfileState')
      const impersonating = sessionStorage.getItem('impersonating') === 'true'
      await Auth.signOut()
      Sentry.setUser(null)
      this.$gtag.set({ user_id: null })

      if (impersonating) {
        sessionStorage.clear()
        localStorage.clear()
        localStorage.setItem('closeImpersonationTab', 'true')
        return
      } else {
        localStorage.clear()
        this.$router.push('/login').catch(() => {})
      }
    },
    getRestriction(item) {
      return conversions.getRestrictionCode(item)
    },
    upload: async function () {
      // create new graphql record
      if (this.stateOf) {
        this.deleteProPic()
      }
      this.uploadProPic = false
      const createdItem = await API.graphql(
        graphqlOperation(createProfilePicture, {
          input: {
            profilePicture: this.uploadFile.name,
            owner: this.cognitoUserName,
          },
        })
      )

      // upload to s3
      try {
        await Storage.put(
          createdItem.data.createProfilePicture.id,
          this.uploadFile,
          {
            level: 'private',
            contentType: this.uploadFile.type,
          }
        )
        await this.listItems()
      } catch (err) {
        console.error('Error uploading file: ', err)
      }
      this.uploadFile = null
    },
    listItems: async function () {
      try {
        await API.graphql({
          query: queries.profilePictureByOwner,
          variables: {
            owner: this.cognitoUserName,
          },
        }).then((response) => {
          const getItems = response
          if (getItems.data.profilePictureByOwner.items.length > 0) {
            ;((this.proPicId = getItems.data.profilePictureByOwner.items[0].id),
              console.log('id', this.proPicId),
              (this.changeOrUpload = 'Change'),
              (this.stateOf = true),
              (this.items = this.urlAdd(
                getItems.data.profilePictureByOwner.items
              )))
          } else {
            this.stateOf = false
            this.changeOrUpload = 'Upload'
          }
        })
      } catch (error) {
        console.error('query profile picture', error)
      }
    },
    deleteProPic: async function () {
      try {
        await API.graphql({
          query: mutations.deleteProfilePicture,
          variables: {
            input: {
              id: this.proPicId,
            },
          },
        })
      } catch (error) {
        console.error('delete profile picture', error)
      }
    },
    urlAdd: async function (items) {
      const result = await Promise.all(
        items.map(async (item) => {
          item.url = await Storage.get(item.id, {
            level: 'private',
          })
          this.proPic = item.url
          // console.log("thispropic ", item.url);
          return item
        })
      )

      return result
    },
    checkRestrict() {
      if (!this.currentUserProfile.length) {
        if (this.userPermissions?.restrictReason != null) {
          if (this.userPermissions?.restrictReason.length > 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getStatusClass(status) {
      return status === 'open'
        ? 'icon69'
        : status === 'closed'
          ? 'icon70'
          : status === 'extended-hours'
            ? 'icon71'
            : 'blue--text' // Default condition
    },
    async getTrafixStatus() {
      this.connection = false
      this.loggedInToTrafix = false

      let trafixUrl = 'https://trafix-demo.tacoai.net'
      if (process.env.NODE_ENV === 'release') {
        trafixUrl = 'https://trafix.tacoai.net'
      }

      try {
        const response = await fetch(trafixUrl, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        })
        if (!response.ok) {
          console.error(`Error: ${response.status} - ${response.statusText}`)
          return
        }
        const data = await response.json()
        this.connection = data['Created connection to Trafix'] ?? false
        this.loggedInToTrafix = data['Logged in to Trafix'] ?? false
      } catch (error) {
        console.error(error)
      }
    },
    async getDxFeedStatus() {
      return fetch(`${process.env.VUE_APP_SOCKET_IO_URL}/status`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          this.dxconnection = data.status === 'OK'
          return data
        })
        .catch((e) => console.error(e))
    },
    async getMarketStatus() {
      try {
        const response = await fetch(
          `https://api.polygon.io/v1/marketstatus/now?apiKey=${process.env.VUE_APP_POLYGON_API_KEY}`,
          {
            method: 'GET',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          }
        )

        if (!response.ok) {
          this.marketStatuses = {}
          return
        }

        const { exchanges: marketStatuses } = await response.json()
        this.marketStatuses = marketStatuses
      } catch {
        this.marketStatuses = {}
      }
    },
  },
  computed: {
    ...mapGetters({
      accountNumber: 'getcurrentlySelectedAccountInformation',
      currentUserProfile: 'getcurrentlySelectedAccountInformationArray',
      groups: 'getUserGroups',
      userPermissions: 'getUserPermissions',
    }),
    marketStatusClasses() {
      return {
        nasdaq: this.getStatusClass(this.marketStatuses.nasdaq),
        nyse: this.getStatusClass(this.marketStatuses.nyse),
        otc: this.getStatusClass(this.marketStatuses.otc),
      }
    },
  },
  async mounted() {
    this.storedGroups = JSON.parse(localStorage.getItem('groups'))

    if (!this.storedGroups.includes('clients')) {
      await Promise.all([this.getTrafixStatus(), this.getDxFeedStatus()])

      setInterval(async () => {
        await Promise.all([this.getTrafixStatus(), this.getDxFeedStatus()])
      }, 60_000)
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
    // Clean up auth sync
    if (this.authSync) {
      this.authSync.close()
    }
  },
  created: async function () {
    // Initialize auth sync
    this.authSync = new AuthSync()
    ;(await this.getMarketStatus(),
      setInterval(async () => {
        await this.getMarketStatus()
      }, 60_000 * 5))

    await Auth.currentAuthenticatedUser().then((user) => {
      this.cognitoUserName = user.username
      this.email = user.attributes.email
      this.email = this.email.match(/^([^@]*)@/)
      this.email = this.email[1]
    })
  },
}
</script>
<style scoped>
.restrictText {
  font-size: 13px;
}

#top >>> .v-toolbar__content {
  min-height: 40px;
  max-height: 40px;
}

#clock {
  /* font-family: "Share Tech Mono", monospace;
  color: #ffffff; */
  /* text-align: center; */
  /* position: absolute; */
  /* left: 50%;
  top: 55%; */
  /* transform: translate(-50%, -50%); */
  font-size: 14px;
  color: #daf6ff;
  text-shadow:
    0 0 20px rgba(10, 175, 230, 1),
    0 0 20px rgba(10, 175, 230, 0);
}

#clock2 {
  /* font-family: "Share Tech Mono", monospace;
  color: #ffffff; */
  /* text-align: center; */
  /* position: absolute; */
  /* left: 30%;
  top: 50%; */
  /* transform: translate(-50%, -50%); */
  font-size: 16px;
  color: #daf6ff;
  text-shadow:
    0 0 20px rgba(10, 175, 230, 1),
    0 0 20px rgba(10, 175, 230, 0);
}

#words {
  /* font-family: "Share Tech Mono", monospace;
  color: #ffffff; */
  /* text-align: center; */
  /* position: absolute; */
  font-size: 11px;
  /* left: 30%;
  top: 63%;
  transform: translate(-50%, -50%); */
  color: #daf6ff;
  text-shadow:
    0 0 20px rgba(10, 175, 230, 1),
    0 0 20px rgba(10, 175, 230, 0);
}

#words2 {
  color: #ffffff;
  color: #daf6ff;
  text-shadow:
    0 0 20px rgba(10, 175, 230, 1),
    0 0 20px rgba(10, 175, 230, 0);
}

.icon69 {
  color: lime;
}

.icon70 {
  color: red;
}

.icon71 {
  color: yellow;
}

/deep/ .v-toolbar__content {
  padding: 0px !important;
}
</style>
<!-- TODO uncommenting this gives the words highlights -->
<!-- <style>
.v-data-table {
  color: #ffffff;
  color: #daf6ff;
  text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0);
}
</style> -->
